module.exports = __webpack_public_path__ + "static/media/team10.52d68a5f.png";